// The server reads the JSON file too.
import appMount from './app-mount.json'

/** The path the app is mounted under, such as `/connect`. */
export const APP_BASE_PATH = `/${appMount.appPath}`
